import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Packages
import { Button, Form, Input, Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

// Actions
import { get_all_actions, action_create, action_update } from '../../../redux/actions/actionsActions';

// Utils
import isEmpty from '../../../utils/isEmpty';

const ActionForm = (props) => {
	const { messageApi, isModalOpen, setIsModalOpen, update, actionToUpdate, pageSize, skip } = props;

	const { t } = useTranslation();

	const dispatch = useDispatch();

	const { action_create_loading, action_update_loading } = useSelector(state => state.actions);
	
	const [form] = Form.useForm();

	useEffect(() => {
		if (!isEmpty(actionToUpdate)) {
			form.setFieldsValue(actionToUpdate);
		}
	}, [actionToUpdate]);

	const handleCancel = (finish) => {
		setIsModalOpen(false);
		form.resetFields();

		if (finish) {
			const filters = { skip: skip, limit: pageSize };
			dispatch(get_all_actions(filters));
		}
	}

	const onOk = () => {
		form
			.validateFields()
			.then((values) => {
				if (!update) {
					// Create
					dispatch(action_create(values, () => handleCancel(true)));
				}
				else {
					// Update
					dispatch(action_update(messageApi, actionToUpdate?._id?.$oid, values, () => handleCancel(true)));
				}
			})
			.catch((info) => {
				console.error(info);
			});
	}

	return (
		<Modal
			title={!update ? t('actions.create.modalTitle') : t('actions.edit.modalTitle')}
			centered
			open={isModalOpen}
			onCancel={() => handleCancel(false)}
			maskClosable={false}
			width={700}
			footer={[
				<Button
					key='submit'
					type='primary'
					loading={!update ? action_create_loading : action_update_loading}
					onClick={onOk}
				>
					{t('buttons.save')}
				</Button>,
			]}
		>
			<Form
				labelCol={{ span: 5 }}
				form={form}
			>
				<Form.Item
					label={t('form.label.name')}
					name='name'
					rules={[
						{
							required: true,
							message: t('form.rules.required'),
						}
					]}
				>
					<Input placeholder={t('form.placeholders.name')} />
				</Form.Item>
				<Form.Item
					label={t('form.label.description')}
					name='description'
					rules={[
						{
							required: true,
							message: t('form.rules.required'),
						}
					]}
				>
					<Input placeholder={t('form.placeholders.description')} />
				</Form.Item>
			</Form>
		</Modal>
	)
}

ActionForm.propTypes = {
	messageApi: PropTypes.object.isRequired,
	isModalOpen: PropTypes.bool.isRequired,
	setIsModalOpen: PropTypes.func.isRequired,
	update: PropTypes.bool.isRequired,
	actionToUpdate: PropTypes.object.isRequired,
	pageSize: PropTypes.number.isRequired,
	skip: PropTypes.number.isRequired
}

export default ActionForm;
